import ApiGateway from '../api-gateway/api-gateway';
import { tokenIsValid } from '@app/lib/utils';
import { cognitoUser } from '@app/lib/cognito';
import { store } from '@app/store';
import { actionCreators as authActionCreators } from '@app/common/auth/auth.reducer';

export default {
  async attachLicense(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.post(`/sites/${id}/licenses`, payload);
      return result.data;
    }
    else {
      //refresh token instead of immediate logout
      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {
        // Only logout if refresh fails
        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },

  async getSiteStatus(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/sites/${id}/status`);
      return result.data.status;
    }
    else {

      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {

        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },

  async getSiteMetrics(id) {
    // Temporarily disabled metrics API calls
    // Return empty object to prevent errors
    return { metrics: {} };
    
    /*
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/sites/${id}/metrics`);
      return result.data.metrics;
    }
    else {
          cognitoUser.signOut();
    }
    */
  },

  async getRouting(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/sites/${id}/routing`);
      return result?.data;
    }
    else {

      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {

        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },

  async addRouting(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.post(`/sites/${id}/routing`, payload);
      return result.data;
    }
    else {

      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {

        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },

  async addSiteToWan(siteId, wanId) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.post(`/sites/${siteId}/wans`, { wan_id: wanId });
      return result.data;
    }
    else {

      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {
        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },

  async removeSiteFromWan(siteId) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.delete(`/sites/${siteId}/wans`, {});
      return result.data;
    }
    else {

      try {
        store.dispatch(authActionCreators.tokenRefreshRequest());

        return {};
      } catch (error) {

        if (cognitoUser && typeof cognitoUser.signOut === 'function') {
          cognitoUser.signOut();
        } else {
          console.warn('Session expired: Auth provider not available for logout');
        }
        return {};
      }
    }
  },
}
